import React from 'react';
import { Switch, Route, useHistory } from 'react-router-dom';
import PrivateRoute from './components/common/PrivateRoute';
import './App.scss';
import MiniVariantDrawer from './components/common/AppBar';
import Search from './components/Search/Search';
import Settings from './components/Settings';
import Login from './components/Login';
import * as AppBar from './Constants/AppBar';
import Results from './components/Results/Results';
import BackDropOverlay from './components/common/BackDrop';
import * as globalConstants from './Constants/global';
import CustomizedSnackbars from './components/common/SnackBar';
import AlertDialogSlide from './components/common/Dialog';
import ManageAsset from './components/ManageAsset/ManageAsset';
import ManageProduct from './components/ManageProduct/ManageProduct';
import { Grid, makeStyles } from '@material-ui/core/';
import VersionDisplay from './components/versionDisplay';
import UploadCSVLayout from './components/CreateAsset/UploadCSVMain';
import ManualEntryLayout from './components/CreateAsset/ManualEntryMain';
import { useDispatch } from 'react-redux';
import assetAPI from './redux/assetAPI';

const useStyles = makeStyles((theme) => ({
	content: { paddingTop: theme.spacing(10) },
}));

function App() {
	const classes = useStyles();
	const history = useHistory();
	const dispatch = useDispatch();
	// initialize the interceptors
	assetAPI.setupInterceptors(dispatch, history);

	return (
		<Grid container direction="column" alignItems="center">
			<MiniVariantDrawer />
			<BackDropOverlay />
			<CustomizedSnackbars />
			<AlertDialogSlide />
			<VersionDisplay />
			{/* Initializing all the components routes here */}
			<Switch>
				{/* Defining Search as a root component with "/". since we have to land on
      Search page first. */}
				<Route exact path="/login" component={Login} />
				{/* inside switch tag we can only have route or redirect tags. adding React.Fragment block to avoid console warnings.*/}
				<React.Fragment>
					<Grid container item sm={12} md={10} lg={9} className={classes.content}>
						<PrivateRoute exact path={AppBar.Search_Root_NavLink_To} component={Search} />
						{/* Defining alternative route to search component so that we can load search using both "/" and "/Search" */}
						<PrivateRoute exact path={AppBar.Search_Alt_NavLink_To} component={Search} />
						{/* below route is defined to a dedicated health check for kubernetes probes(liveness and readiness) */}
						<Route path={globalConstants.healthCheckUrlRoute}></Route>
						{/* search results route with search term as parameter. */}
						{/* search term param as optional in the route URL  */}
						<PrivateRoute exact path={AppBar.Results_NavLink_To + '/:searchTerm?'} component={Results} />
						<PrivateRoute exact path={AppBar.Create_UploadCsv_NavLink_To} component={UploadCSVLayout} />
						<PrivateRoute exact path={AppBar.Create_ManualEntry_NavLink_To} component={ManualEntryLayout} />
						<PrivateRoute exact path={AppBar.Notifications_NavLink_To} component={Settings} />
						{/* Manage asset route with id param*/}
						<PrivateRoute exact path={AppBar.ManageAssets_NavLink_To + '/:id'} component={ManageAsset} />
						{/* Manage product route with id param */}
						<PrivateRoute
							exact
							path={AppBar.ManageProducts_NavLink_To + '/:id'}
							component={ManageProduct}
						/>
					</Grid>
				</React.Fragment>
			</Switch>
		</Grid>
	);
}

export default App;
